import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    getMenuOptions as getMenuOptionsApi,
    createMenuOption as createMenuOptionApi,
    updateMenuOption as updateMenuOptionApi,
    deleteMenuOption as deleteMenuOptionApi,
} from "../../helpers/backend_helper";

export interface GetMenuOptionsParams {
    [key: string]: unknown;
}

export interface CreateMenuOptionPayload {
    [key: string]: unknown;
}

export interface UpdateMenuOptionPayload {
    optionId: string | number;
    data: Record<string, unknown>;
}

export const getMenuOptions = createAsyncThunk(
    "MenuOptions/getMenuOptions",
    async (_: void, { rejectWithValue }) => {
        try {
            const response = await getMenuOptionsApi();
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const createMenuOption = createAsyncThunk(
    "MenuOptions/createMenuOption",
    async (data: CreateMenuOptionPayload, { rejectWithValue }) => {
        try {
            const response = await createMenuOptionApi(data);
            return {
                request: data,
                response,
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const updateMenuOption = createAsyncThunk(
    "MenuOptions/updateMenuOption",
    async ({ optionId, data }: UpdateMenuOptionPayload, { rejectWithValue }) => {
        try {
            const response = await updateMenuOptionApi(optionId, data);
            return {
                optionId,
                request: data,
                response,
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const deleteMenuOption = createAsyncThunk(
    "MenuOptions/deleteMenuOption",
    async (optionId: string | number, { rejectWithValue }) => {
        try {
            const response = await deleteMenuOptionApi(optionId);
            return {
                optionId,
                response,
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
